import { ERCard, DateTimeField, ERSelectHospital } from '@gv/triage-components';

import { useHospitalTime } from 'components/cases/form/useHospitalTime';
import {
  useFormEntities,
  callOutcomeModel,
  CheckProtocolsInfo,
} from 'components/cases/form';

import { ReferToAnotherERProps } from './types';

const {
  emergency: { referToAnotherER },
} = callOutcomeModel;

export const ReferToAnotherEr = ({
  options,
  hideNotes,
  setReferral,
  mainHospital,
  referralData,
  isERHospital,
  hospitalsOptions,
}: ReferToAnotherERProps) => {
  const { hospital, isMainHospital } = useFormEntities();
  const { isHospitalOpen } = useHospitalTime();

  return (
    <>
      <ERSelectHospital
        options={options}
        isERHospital={isERHospital}
        referToEr={referToAnotherER}
        hospitalName={hospital?.name}
        isHospitalOpen={isHospitalOpen}
        isMainHospital={isMainHospital}
        hospitalsOptions={hospitalsOptions}
      />

      <CheckProtocolsInfo hideNotes={hideNotes}>
        {referralData?.hospital && (
          <ERCard
            setReferral={setReferral}
            mainHospital={mainHospital}
            data={referralData.hospital}
            acceptance={referralData.acceptance}
          />
        )}

        <DateTimeField
          timezone={hospital?.timezone}
          name={callOutcomeModel.emergency.referToAnotherER.datetime}
        />
      </CheckProtocolsInfo>
    </>
  );
};
